import axios from "../axios";

const updateBank = async function (accessToken,params) {
    try {
        const response = await axios.post('/bank/updateBank', params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updateBank;
